import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ToSViewer } from '../../components/legal/ToSViewer';
import PublicNavBar from '../../components/layout/PublicNavBar';
import SiteFooter from '../../components/layout/SiteFooter';

export const TermsOfServicePage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  // The page is often opened in a new tab (footer link, window.open from the
  // consent checkboxes). In that case there is no in-app history to go back to,
  // so close the tab; otherwise navigate back, falling back to home.
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.close();
      // If the tab wasn't script-opened (close blocked), go somewhere sane.
      setTimeout(() => navigate('/'), 50);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <PublicNavBar />

      {/* Content */}
      <div className="flex-1 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <ToSViewer mode="page" />

          <div className="mt-8 pt-8 border-t">
            <button
              onClick={handleBack}
              className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              {t('legal.back')}
            </button>
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};
